module.exports = __webpack_public_path__ + "static/media/logo4.18cc3db7.jpg";